import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/Home.css";
import ImageSlider from "../components/ImageSlider";
import heroImage from "../assets/images/aboutpage.jpeg";
import AboutFeaturesSection from "./AboutFeaturesSection";
import Services from "../components/Services";

const Home = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/about");
  };

  return (
    <div>
      <div className="home-container">
        <h1>Welcome to Agr Consultant & Engineer's</h1>
        <h3>Your trusted partner for agricultural services and solutions.</h3>
        <ImageSlider />
      </div>

      <div className="hero-section">
        <div className="hero-image-container">
          <img src={heroImage} alt="AGR Consultant & Engineers" className="hero-image" />
        </div>
        <div className="hero-content">
          <span className="welcome-label">
            <span className="bolt">&#9889;</span>
            &nbsp;WELCOME TO
          </span>
          <h1>AGR Consultant & Engineers</h1>
          <p>
            At AGR, we are your premier destination for comprehensive electrical solutions. From sales and maintenance of ACBs, VCBs, panels, and all types of switchgear, to testing, transformer work, and retrofitting services, we’ve got you covered. With a team of experienced electricians, we ensure top-notch service quality and reliability. Choose AGR for all your electrical needs and experience excellence at every step.
          </p>
          <button className="learn-btn" onClick={handleLearnMore}>
            LEARN MORE
          </button>
        </div>
      </div>
      <div >
          {/*<span className="welcomeservices-label">
            <span className="bolt">&#9889;</span>
            &nbsp;
             <p className="center-text">What we offer ?</p>
          </span>*/}
        < Services />
          <AboutFeaturesSection />
        </div>

      <Footer />
    </div>
  );
};

export default Home;